export default import.meta.ROLLDOWN_FILE_URL_JcJu2ww5la6KY1VF5rHq_w